import React from 'react';
import './styles.scss';

const HeaderSection = React.memo(({ children }) => {
    return <div className="fm-header-section">{children}</div>;
});

export default HeaderSection;
